// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/stethoscope.js';

import { paths } from '../generated/stethoscope';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('stethoscope', Original, paths);
